import { observer } from 'mobx-react-lite';
import styles from '../index.module.scss';
import AmendClinicalEvent from '../../../../ClinicalEvents/Actions/AmendClinicalEvent';
import VoidClinicalEvent from '../../../../ClinicalEvents/Actions/VoidClinicalEvent';
import { eventType } from '../../../../ClinicalEvents/events-fields-options';
import useRtmEventsService from '../../../../ClinicalEvents/service';
import { head } from 'lodash';
import { useParams } from 'react-router';

const EventDetailsActions = ({ uuid }: { uuid: string }) => {
  const { patientUuid = '' } = useParams<{ patientUuid: string }>();
  const { getEvent } = useRtmEventsService(patientUuid);
  const event = getEvent(uuid);

  const currentVersion = head(event?.versions);

  return (
    <div className={styles.actions}>
      <VoidClinicalEvent
        uuid={uuid}
        isMonitoring={
          currentVersion?.eventName === eventType.monitoringAndAssessment
        }
      />
      <AmendClinicalEvent uuid={uuid} />
    </div>
  );
};

export default observer(EventDetailsActions);
